<template>
  <v-container fluid class="pa-8">
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8">
        <div class="text-center mb-8">
          <h1 class="text-h3 font-weight-bold primary--text mb-4">Ajuda</h1>
          <p class="text-h6 grey--text text--darken-1">
            Se precisar de ajuda com o Canal do Veículo, entre em contato com os endereços abaixo:
          </p>
        </div>

        <v-row>
          <v-col cols="12" md="6">
            <div class="help-section pa-6 d-flex flex-column align-center">
              <v-avatar color="primary" size="80" class="mb-4">
                <v-icon size="40" color="white">mdi-email-outline</v-icon>
              </v-avatar>
              
              <h3 class="text-h5 font-weight-bold mb-2">E-mail</h3>
              
              <v-chip 
                class="mt-3 px-6 py-5" 
                color="grey lighten-3"
                text-color="primary"
                @click="copyEmail">
                <v-icon left small>mdi-email</v-icon>
                parceiros@themediatrade.com
                <v-icon right small>mdi-content-copy</v-icon>
              </v-chip>

              <v-btn 
                color="primary" 
                class="mt-6" 
                large
                rounded
                @click="openEmail">
                <v-icon left>mdi-open-in-new</v-icon>
                Enviar E-mail
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="help-section pa-6 d-flex flex-column align-center">
              <v-avatar color="success" size="80" class="mb-4">
                <v-icon size="40" color="white">mdi-whatsapp</v-icon>
              </v-avatar>
              
              <h3 class="text-h5 font-weight-bold mb-2">WhatsApp</h3>
              
              <v-chip 
                class="mt-3 px-6 py-5" 
                color="grey lighten-3"
                text-color="success"
                @click="copyPhone">
                <v-icon left small>mdi-phone</v-icon>
                (11) 988729007
                <v-icon right small>mdi-content-copy</v-icon>
              </v-chip>

              <v-btn 
                color="success" 
                class="mt-6" 
                large
                rounded
                @click="openWhatsApp">
                <v-icon left>mdi-whatsapp</v-icon>
                Abrir WhatsApp
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-snackbar 
          v-model="snackbar" 
          :timeout="3000" 
          color="success"
          top
          right>
          {{ snackbarMessage }}
          <template v-slot:action="{ attrs }">
            <v-btn
              color="white"
              text
              v-bind="attrs"
              @click="snackbar = false">
              Fechar
            </v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'HelpView',
  
  data() {
    return {
      snackbar: false,
      snackbarMessage: '',
      email: 'parceiros@themediatrade.com',
      phone: '5511988729007',
      phoneFormatted: '(11) 988729007'
    }
  },

  methods: {
    openEmail() {
      const subject = 'Ajuda - Canal do Veículo';
      const body = 'Olá, gostaria de ajuda com a plataforma Canal do Veículo.';
      window.open(`mailto:${this.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`, '_blank');
    },

    openWhatsApp() {
      const message = 'Olá, gostaria de ajuda com a plataforma Canal do Veículo';
      window.open(`https://wa.me/${this.phone}?text=${encodeURIComponent(message)}`, '_blank');
    },
    copyEmail() {
      this.copyToClipboard(this.email, 'E-mail copiado para a área de transferência!');
    },

    copyPhone() {
      this.copyToClipboard(this.phoneFormatted, 'Telefone copiado para a área de transferência!');
    },

    copyToClipboard(text, message) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.snackbarMessage = message;
          this.snackbar = true;
        }).catch(err => {
          console.error('Erro ao copiar:', err);
          this.fallbackCopy(text, message);
        });
      } else {
        this.fallbackCopy(text, message);
      }
    },

    fallbackCopy(text, message) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        this.snackbarMessage = message;
        this.snackbar = true;
      } catch (err) {
        console.error('Erro ao copiar:', err);
      }
      document.body.removeChild(textArea);
    }
  }
}
</script>

<style scoped>
.help-section {
  height: 100%;
}

.v-chip {
  cursor: pointer;
  transition: all 0.2s ease;
}

.v-chip:hover {
  opacity: 0.8;
}
</style>
